module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('notifications', {
    attrs: {
      "animation-type": "velocity",
      "group": "kmb-notifications",
      "animation": _vm.animation,
      "duration": 4200,
      "width": 315,
      "position": "bottom left"
    },
    scopedSlots: _vm._u([
      ["body", function(props) {
        return [_c('NotificationBody', {
          attrs: {
            "config": props,
            "description": props.item.data.description,
            "first-action": props.item.data.firstAction,
            "second-action": props.item.data.secondAction
          }
        })]
      }]
    ])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c87f3e54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/notifications/NotificationContainer.vue
// module id = 319
// module chunks = 22